<template>
  <div>
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="container" v-loading="loading">
        <!--        <template v-if="!detail_show">-->
        <!--          <titleConfig-->
        <!--              :title="-->
        <!--              langSet == 'cn' ? '发布商机' : 'Publish business opportunities'-->
        <!--            "-->
        <!--              :type="2"-->
        <!--          ></titleConfig>-->
        <!--          <div class="_search">-->
        <!--            <Select_input_search-->
        <!--                :options="search_options"-->
        <!--                :placeholder_select=" langSet == 'cn' ?'筛选':'Filter' "-->
        <!--                :placeholder_input="langSet == 'cn' ?'请搜索关键词':'Please search for keywords'"-->
        <!--                :select_key="'id'"-->
        <!--                :select_label="-->
        <!--                langSet == 'cn' ? 'category_name' : 'en_category_name'-->
        <!--              "-->
        <!--                :label_list="label_list"-->
        <!--                @query_change="query_change"-->
        <!--            ></Select_input_search>-->
        <!--            &lt;!&ndash;          en_category_name &ndash;&gt;-->
        <!--          </div>-->
        <!--          <Business_list-->
        <!--              :businessList="businessList"-->
        <!--              @item_click="item_click"-->
        <!--          ></Business_list>-->
        <!--          <nodata v-if="businessList.length == 0"></nodata>-->
        <!--          <div class="block">-->
        <!--            <el-pagination-->
        <!--                @size-change="sizeChange"-->
        <!--                @current-change="currentChange"-->
        <!--                :page-sizes="[6, 12, 24]"-->
        <!--                :page-size="pageSize"-->
        <!--                layout="prev, pager, next,sizes"-->
        <!--                :total="total"-->
        <!--            >-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--        </template>-->
        <template>
          <titleConfig
            v-if="false"
            :title="
              langSet == 'cn' ? '商机详情' : 'Business opportunity details'
            "
            :type="2"
          ></titleConfig>
          <newTitle
            :title="langSet === 'cn' ? '商机详情' : 'Business opportunity details'"
          ></newTitle>
          <div class="business_box">
            <div class="top_title">
              <div class="title_picture">
                <img :src="business_detail.avatar_image" alt="" />
                <img
                  v-if="business_detail.exhibitor_long_id"
                  src="@/assets/authentication.png"
                  alt=""
                />
              </div>
              <div>
                <div class="title_name">
                  <div>{{ business_detail.name }}</div>
                  <div>{{ business_detail.duty }}</div>
                </div>
                <div class="company">{{ business_detail.company }}</div>
              </div>
            </div>
            <div class="flex fitter_right">
              <div
                :class="[
                  'Collection',
                  business_detail.is_collect == 0 ? '' : 'Collection_change',
                ]"
                @click="collect"
              >
                <div>
                  {{
                    business_detail.is_collect == 0
                      ? langSet == "cn"
                        ? "收藏"
                        : "collect"
                      : langSet == "cn"
                      ? "已收藏"
                      : "Collected"
                  }}
                </div>
                <div>|</div>
                <img class="Collection_image" src="@/assets/aixin.png" alt="" />
              </div>
              <div class="response" @click="response_click">
                {{ langSet == "cn" ? "我要应答" : "I need to respond" }}
              </div>
            </div>
            <!--          <div class="see_button">查看详情</div>-->
          </div>
          <div class="content_middle">
            <Content_top
              :title="langSet == 'cn' ? '产品类别' : 'Product Category'"
            ></Content_top>
            <div class="business_label">
              {{
                langSet == "cn"
                  ? business_detail.product_category
                  : business_detail.product_category_en
              }}
            </div>
            <Content_top
              :title="langSet == 'cn' ? '需求描述' : 'Requirement'"
            ></Content_top>
            <div class="Requirement_text">
              {{ business_detail.requirement }}
            </div>
            <div class="for_image">
              <el-image
                class="item_image"
                v-for="(item, index) in business_detail.imgs"
                :key="index"
                :src="item"
                @click="amplify(item)"
              ></el-image>
            </div>
          </div>
          <template v-if="reply_list_show">
            <div v-if="business_detail.examine == 1">
              <div class="_list_class">
                <Content_top
                  :title="langSet == 'cn' ? '应答列表' : 'Response List'"
                ></Content_top>
                <div
                  class="list_item"
                  v-for="(item, index) in reply_lists"
                  :key="index"
                >
                  <div class="Personal">
                    <div class="Personal_img">
                      <img :src="item.avatar_image" alt="" />
                      <img
                        v-if="item.exhibitor_long_id"
                        src="@/assets/authentication.png"
                        alt=""
                      />
                    </div>
                    <div class="Personal_f">
                      <div>
                        <div class="flex Personal_text">
                          <div>{{ item.name }}</div>
                          <div>{{ item.duty }}</div>
                        </div>
                        <div>{{ item.company }}</div>
                      </div>
                    </div>
                  </div>
                  <div>{{ item.response_content }}</div>
                </div>
              </div>
              <div class="del_button" @click="business_publish_delete()">
                {{ langSet == "cn" ? "删除需求" : "Delete" }}
              </div>
            </div>
            <div class="shImage" v-if="business_detail.examine == 0">
              <img src="@/assets/shz.png" />
            </div>
            <div class="shImage" v-if="business_detail.examine == 2">
              <img src="@/assets/bh.png" />
            </div>
          </template>
          <div style="margin-bottom: 80px"></div>
        </template>
      </div>
    </div>
    <bottom></bottom>
    <div class="add_round" @click="before_add_round" v-if="!reply_list_show">
      <div>+</div>
    </div>
    <div class="dialog_box">
      <el-dialog
        v-if="dialogVisible"
        title="请填写您的应答信息"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div>
          <div class="dialog_line"></div>
          <div class="dialog_box_top">
            <div class="dialog_title_picture">
              <img :src="userInfo.avatar_uri" alt="" />
              <img
                v-if="userInfo.exhibitor_long_id"
                src="@/assets/authentication.png"
                alt=""
              />
            </div>
            <div style="color: #ffffff">
              <div class="dialog_title_name">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.position }}</div>
              </div>
              <div class="dialog_company">{{ userInfo.company_name }}</div>
            </div>
            <!--            <img class="dialog_edit_img" src="@/assets/edit.png" alt=""/>-->
          </div>
          <el-input
            type="textarea"
            :rows="7"
            :placeholder="
              langSet == 'cn'
                ? '请详细描述您的需求'
                : 'Please provide a detailed description of your requirements'
            "
            v-model="request_content"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button class="dialog_submit" type="primary" @click="submit">{{
            langSet == "cn" ? "提 交" : "Submit"
          }}</el-button>
        </span>
      </el-dialog>
    </div>

    <Dialog_release
      v-if="dialog_release"
      @add_round="add_round"
      :dialog_release="dialog_release"
      :publication_type="label_value"
      :options="search_options"
    ></Dialog_release>
    <template class="amplify_image">
      <el-dialog :visible.sync="amplify_image">
        <img width="100%" :src="amplify_imageUrl" alt="" />
      </el-dialog>
    </template>
  </div>
</template>
<script>
import top from "@/components/top.vue";
// import topPiece from "@/components/topPiece.vue";
import bottom from "@/components/bottom.vue";
import Select_input_search from "@/components/Select_input_search.vue";
import newTitle from "@/components/new_title.vue";
import titleConfig from "@/components/title.vue";
import {
  business_publish_delete,
  business_publish_detail,
  business_publish_lists,
  business_publish_product_cate,
  business_reply_add,
  business_reply_lists,
} from "@/api/business_api";
import Business_list from "@/views/business/component/business_list.vue";
import nodata from "@/components/nodata.vue";
import { public_collect } from "@/api/api";
import { company_detail } from "@/api/company_api";
import Content_top from "@/components/content_top.vue";
import { MemberConsultation_add } from "@/api/product_api";
import Dialog_release from "@/views/business/component/dialog_release.vue";
import globalMethods from "@/utils/globalMethods";
import router from "@/router";

export default {
  name: "businessDetail",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    Dialog_release,
    Content_top,
    // nodata,
    // Business_list,
    newTitle,
    titleConfig,
    // Select_input_search,
    bottom,
    //topPiece,
    top,
  },
  data() {
    return {
      langSet: "cn",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      flag: localStorage.getItem("Flag") || "",
      reply_list_show: false,
      search_options: [],
      dialog_release: false,
      placeholder_select: "筛选",
      placeholder_input: "搜索关键词",
      product_category_id: "", //产品类别id
      requirement: "", //描述搜索
      label_value: "1", //筛选项
      businessList: [],
      business_detail: {},
      detail_show: false,
      pageSize: 6,
      pageNo: 1,
      total: 0,
      dialogVisible: false,
      publication_type: "1", //发布类型 1-供应类 2-采购类
      request_content: "",
      loading: false,
      label_list: [
        {
          name: "供应商机",
          name_en: "supply",
          value: "1",
        },
        {
          name: "需求商机",
          name_en: "demand",
          value: "2",
        },
      ],
      amplify_image: false,
      amplify_imageUrl: "",
      reply_lists: [],
      metaData: {},
    };
  },
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  async mounted() {
    this.langSet = this.$language;
    let query = this.$route.query;
    if (query.detail_show) {
      this.loading = true;
      await this.go_to_detail(query);
      if (query.reply_list_show) {
        this.reply_list_show = query.reply_list_show;
        await this.get_business_reply_lists();
      }
      this.loading = false;
    } else {
      // await this.get_product_cate();
      // await this.get_lists();
    }
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async business_publish_delete() {
      const res = await business_publish_delete({
        id: this.business_detail.id,
      });
      this.$router.go(-1);
    },
    async go_to_detail(query) {
      await this.get_business_publish_detail(query.id);
      this.detail_show = query.detail_show;
    },
    query_change(data) {
      this.product_category_id = data.select_value;
      this.page_no = data.pageNo;
      this.requirement = data.search_input;
      this.label_value = data.label_value;
      this.get_lists();
    },
    async item_click(item) {
      await this.get_business_publish_detail(item.id);
      this.details_show_change();
    },
    async get_business_publish_detail(id) {
      const res = await business_publish_detail({ id: id });
      this.business_detail = res.data;
    },
    details_show_change() {
      this.detail_show = !this.detail_show;
      window.scrollTo(0, 0);
    },
    async get_product_cate() {
      const res = await business_publish_product_cate();
      this.search_options = res.data;
    },

    async get_lists() {
      let data = {
        category: this.label_value, //需求类别
        requirement: this.requirement, //描述
        product_category_id: this.product_category_id, //产品类别id
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      const res = await business_publish_lists(data);
      this.businessList = res.data.lists;
      this.total = res.data.count;
    },
    async get_business_reply_lists() {
      let data = {
        publish_id: this.business_detail.id,
      };
      const res = await business_reply_lists(data);
      this.reply_lists = res.data.lists;
    },
    currentChange(e) {
      this.pageNo = e;
      this.get_lists();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.get_lists();
    },
    response_click() {
      if (this.flag == "isLogin") {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    async collect() {
      if (this.flag == "isLogin") {
        let data = {
          action: this.business_detail.is_collect == 0 ? 1 : 0,
          type: "business",
          dataid: this.business_detail.id,
        };
        const res = await public_collect(data);
        this.$message({ message: res.msg, type: "success" });
        this.get_business_publish_detail(this.business_detail.id);
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    handleClose(done) {
      done();
    },
    async submit() {
      let data = {
        publish_id: this.business_detail.id,
        response_content: this.request_content,
      };
      console.log(this.business_detail);
      const res = await business_reply_add(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.dialogVisible = false;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    before_add_round() {
      if (this.flag == "isLogin") {
        if (this.label_value == 1) {
          if (this.userInfo.company_long_id) {
            this.add_round();
          } else {
            this.$message.warning("请先认证展商");
          }
        } else {
          this.add_round();
        }
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    add_round() {
      this.dialog_release = !this.dialog_release;
    },
    amplify(item) {
      this.amplify_image = true;
      this.amplify_imageUrl = item;
    },
  },
};
</script>


<style scoped lang="scss">
._search {
  margin: 40px 0 20px 0;
}

/deep/ .el-pagination {
  text-align: center;
  margin: 50px 0 100px 0;
}

//详情
.business_box {
  height: 128px;
  background: #004190;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin: 40px 0 30px 0;

  .top_title {
    display: flex;

    .title_picture {
      position: relative;
      margin-right: 20px;
    }

    .title_picture > img:first-child {
      width: 65px;
      height: 65px;
      border-radius: 50%;
    }

    .title_picture > img:nth-child(2) {
      width: 20px;
      height: 20px;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .title_name {
      display: flex;
      margin-bottom: 5px;
      align-items: center;
    }

    .title_name > div:nth-child(1) {
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }

    .title_name > div:nth-child(2) {
      margin-left: 10px;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      line-height: 21px;
      text-align: center;
      font-style: normal;
    }

    .company {
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      line-height: 21px;
      text-align: left;
      font-style: normal;
    }
  }

  .Collection {
    width: 124px;
    height: 40px;
    background: #3d82d6;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 15px;
  }

  .Collection_change {
    background: #e62344;
  }

  .Collection_image {
    width: 15px;
    height: 13px;
  }

  .Collection > div:nth-child(2) {
    margin: 0 10px;
  }

  .response {
    width: 124px;
    height: 40px;
    background: #3d82d6;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.content_middle {
  padding: 30px;
  background: #f7f8fa;
  //margin-bottom: 80px;
}

._list_class {
  padding: 30px;
  background: #f7f8fa;
  margin-top: 30px;

  .list_item {
    width: calc((100% - 40px) / 3);
    height: 144px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    margin: 0 20px 20px 0;
    line-height: 25px;

    div:nth-child(2) {
      font-weight: 400;
      font-size: 16px;
      color: #555555;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 控制显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .Personal {
      display: flex;
      margin-bottom: 15px;

      .Personal_img {
        position: relative;
        margin-right: 10px;

        img:nth-child(1) {
          width: 65px;
          height: 65px;
          border-radius: 50%;
        }

        img:nth-child(2) {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }

      .Personal_f {
        display: flex;
        align-items: center;

        .Personal_text {
          align-items: center;

          div:nth-child(1) {
            font-weight: 600;
            font-size: 18px;
            color: #000000;
            line-height: 25px;
            letter-spacing: 1px;
            text-align: left;
            font-style: normal;
          }

          div:nth-child(2) {
            margin-left: 5px;
            font-weight: 400;
            font-size: 15px;
            color: #000000;
            line-height: 25px;
            text-align: center;
            font-style: normal;
          }
        }
      }
    }
  }
}

.shImage {
  > img {
    width: 200px;
    margin: auto;
  }
}

.del_button {
  width: 220px;
  height: 52px;
  background: #e62344;
  border-radius: 9px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 86px auto 0;
  cursor: pointer;
}

.business_label {
  width: 96px;
  height: 30px;
  background: #f8e4e8;
  border-radius: 3px;
  font-weight: 400;
  font-size: 16px;
  color: #e62344;
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  margin-bottom: 40px;
}

.for_image {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.item_image {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-right: 30px;
  cursor: pointer;
}

/deep/ .el-image__error {
  background: #ffffff;
}

//        //弹窗

.dialog_box {
  /deep/ .el-dialog {
    top: 5%;
    width: 480px !important;
    height: 445px !important;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }
}

/deep/ .el-dialog__footer {
  position: absolute;
  display: flex;
  margin: auto;
  left: 0;
  right: 0;
  justify-content: center;
  bottom: 0;
}

/deep/ .el-dialog__body {
  padding: 10px 30px 30px 30px !important;
}

.dialog_line {
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
}

.dialog_box_top {
  position: relative;
  display: flex;
  padding: 10px;
  align-items: center;
  height: 96px;
  background: #004190;
  border-radius: 8px;
  margin: 20px 0 15px 0;
}

.dialog_title_picture {
  position: relative;
  margin-right: 10px;
}

.dialog_title_picture > img:first-child {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}

.dialog_title_picture > img:nth-child(2) {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.dialog_title_name {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
}

.dialog_title_name > div:nth-child(1) {
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  letter-spacing: 1px;
  text-align: center;
  font-style: normal;
}

.dialog_title_name > div:nth-child(2) {
  margin-left: 10px;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.dialog_company {
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.dialog_edit_img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}

.dialog_footer {
}

.dialog_submit {
  width: 180px;
  height: 42px;
  border-radius: 9px;
  background-color: #004190;
  border-color: #004190;
}

.dialog_submit:hover {
  background-color: #004190;
  opacity: 0.9;
}

.dialog_submit:focus {
  background-color: #004190;
  opacity: 1;
}

/deep/ .el-dialog__footer {
  position: absolute;
  display: flex;
  margin: auto;
  left: 0;
  right: 0;
  justify-content: center;
  bottom: 0;
}

.add_round {
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 40%;
  width: 70px;
  height: 70px;
  background: #004190;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ffffff;
    color: #004190;
    text-align: center;
    line-height: 40px;
    font-size: 40px;
  }
}

@media only screen and (max-width: 767px) {
  .business_box {
    position: relative;
    height: 2.02rem;
    box-sizing: border-box;
    padding: 0.38rem 0.29rem;
    margin: 0.38rem 0 1.54rem;

    .fitter_right {
      width: 100%;
      position: absolute;
      top: 2.4rem;
      left: 0;
      justify-content: center;
    }
  }
  .add_round {
    width: 1.12rem;
    height: 1.12rem;

    div {
      width: 0.58rem;
      height: 0.58rem;
      font-size: 1rem;
    }
  }
  .content_middle {
    padding: 0.29rem;

    .business_label {
      width: 1.46rem;
      height: 0.46rem;
      border-radius: 0.06rem;
      font-weight: 400;
      font-size: 0.21rem;
      color: #e62344;
      line-height: 0.31rem;
      text-align: left;
      font-style: normal;
      margin-bottom: 1.23rem;
    }

    .Requirement_text {
      font-weight: 400;
      font-size: 0.31rem;
      color: #555555;
      line-height: 0.46rem;
      text-align: left;
      font-style: normal;
    }

    .for_image {
      margin-top: 0.38rem;
      height: 1.98rem;
      border-radius: 0.15rem;
      justify-content: space-between;

      .item_image {
        width: 1.98rem;
        height: 1.98rem;
        margin-right: 0;
      }
    }
  }
  .shImage {
    margin-top: 0.38rem;

    > img {
      width: 2.5rem;
    }
  }

  .dialog_box {
    /deep/ .el-dialog {
      width: 6.54rem !important;
      height: 7.69rem !important;
      background: #ffffff;
      border-radius: 0.38rem;
    }

    .dialog_box_top {
      padding: 0.19rem;
      height: auto;
      background: #004190;
      border-radius: 0.15rem;
    }
  }
}
</style>